import script from "./AddReview.vue?vue&type=script&setup=true&lang=js"
export * from "./AddReview.vue?vue&type=script&setup=true&lang=js"

import "./AddReview.vue?vue&type=style&index=0&id=c5bf8f9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5bf8f9a"]])

export default __exports__